export default "__VITE_ASSET__CnMzkm8u__"